import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { io } from 'socket.io-client';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class SocketIoClientService {
  public pdfUrl:Subject<string> = new Subject()
  public socket;

  private readonly socketEndpoint: string
  constructor(private keycloak: Keycloak) {
    this.socketEndpoint = window.location.protocol.replace('http', 'ws') + '//' + window.location.host
  }

  public async setupWebSocketConnection(): Promise<void> {
    await this.keycloak.updateToken(30);
    this.socket = io(this.socketEndpoint, {
      path: '/api/webapp/ws',
      transports: ['websocket'],
      query: { token: this.keycloak.token },
    });
  }

  public generatePdf(data: any): void{
    this.socket.emit('pdfGenerate',data);
    this.socket.on('pdfGenerateFinished',(res)=>{
      this.pdfUrl.next(res.fileUrl);
    });
    this.socket.on('pdfGenerateFailed',(res)=>{
      this.pdfUrl.error(res || "PDF genereren is mislukt");
    })
  }
  public generateQrCode(pages: number, small: boolean): void{
    this.socket.emit('qrGenerate', {pages, small});
    this.socket.on('pdfGenerateFinished',(res)=>{
      this.pdfUrl.next(res.fileUrl);
    });
    this.socket.on('pdfGenerateFailed',(res)=>{
      this.pdfUrl.error(res || "QR code genereren is mislukt");
    })
  }

  public disconnectSocket(): void{
    this.socket.disconnect();
  }
}
